var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"analysis-tutorial-page col-block",style:({ height: '100%', width: '100%', 'min-width': '1350px' })},[_c('tutorialMain',{attrs:{"type":_vm.tutorialType,"params":{
      renderItem: _vm.renderItem,
      display: _vm.display,
      toggle: _vm.toggle
    }}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-683e1f70","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/analysis/tutorial.vue
// module id = null
// module chunks = 